import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';

type Props = {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
};

const DonateButton: React.StatelessComponent<Props> = ({
  isActive,
  name,
  pageSection,
  donate,
}) => {
  const buttonClass = classNames('jg-btn', {
    'is-disabled': !isActive,
  });

  return (
    <a
      data-marker="donate-button"
      onClick={() => donate({ pageSection })}
      href={`${
        config.CROWDFUNDING_BASE_URI
      }/${name}/donate?pageSection=${pageSection}`}
      className={buttonClass}
      styleName="fixed-donate-button"
    >
      Donate
    </a>
  );
};

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx